import { Cart, CartItem } from '../../../types/generated';

export type getCartDataType = (type: string, data: Partial<Cart>) => Partial<Cart> | Partial<CartItem>[];

export enum CART_DATA_TYPES {
  SUMMARY = 'summary',
  ITEMS = 'cartItems',
}
